<template>
    <contract-component 
        title="¿A qué plan desea actualizar él actual?"
        :disabled="true"
        btn_text="Ampliar"
        :submit_func="submit"
        :submitting="submitting"
    ></contract-component>
</template>

<script>
    import ContractComponent from "../components/ContractComponent.vue";
    import { mapActions } from "vuex";

    export default {
        name: "UpgradeContract",
        components: {
            ContractComponent,
        },
        data() {
            return {
                submitting: false,
            };
        },
        methods: {
            async submit() {
                this.submitting = true;
                try {
                    await this.upgradeContract();
                } catch (error) {
                    console.error(error);
                } finally {
                    this.submitting = false;
                    this.$router.push({ name: "document-list" });
                }
            },
            ...mapActions({
                upgradeContract: "contracts/upgradeContract",
            }),
        },
    };
</script>